import { render, staticRenderFns } from "./ReportRoutePlanResult.vue?vue&type=template&id=2d1951a5"
import script from "./ReportRoutePlanResult.vue?vue&type=script&lang=js"
export * from "./ReportRoutePlanResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports